import React from 'react';
import StyledSelect from '../../components/StyledSelect';
import { MEDIA_TYPE_OPTIONS } from './trainAgentConstants';
import { blockStyle, labelStyle, inputStyle, styles } from './trainAgentStyles';

export function TrainAgentMediaBlock({ vm }) {
  const { mediaLibrary, setMediaItem, removeMediaItem, addMediaItem } = vm;
  return (
    <div style={blockStyle}>
      <label style={labelStyle}>Biblioteca de mídia (imagens, GIFs, PDFs, links)</label>
      <p style={{ color: '#B0BEC5', fontSize: '13px', marginBottom: '12px' }}>
        Configure imagens, PDFs e links que o agente pode enviar no chat (ex.: cardápio, fotos de pratos, promoções). No
        treino, use &quot;mostre o [mídia #1]&quot; ou &quot;envie o cardápio&quot; para o agente incluir com [MEDIA:1].
      </p>
      {mediaLibrary.map((item, i) => (
        <div key={i} style={{ ...blockStyle, padding: '16px', marginBottom: '12px', background: 'rgba(0,0,0,0.2)' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
            <span style={{ color: '#00D4FF', fontWeight: '600' }}>Mídia #{i + 1}</span>
            <button type="button" onClick={() => removeMediaItem(i)} style={styles.removeBtn}>
              − Remover
            </button>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: '12px', marginBottom: '10px' }}>
            <div>
              <label style={{ ...labelStyle, fontSize: '11px' }}>Tipo</label>
              <StyledSelect
                value={item.type}
                onChange={(v) => setMediaItem(i, 'type', v)}
                options={MEDIA_TYPE_OPTIONS}
                placeholder="Tipo"
                style={{ marginTop: '6px' }}
              />
            </div>
            <div>
              <label style={{ ...labelStyle, fontSize: '11px' }}>URL</label>
              <input
                type="url"
                value={item.url}
                onChange={(e) => setMediaItem(i, 'url', e.target.value)}
                placeholder="https://..."
                style={{ ...inputStyle, marginTop: '6px' }}
              />
            </div>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '10px' }}>
            <div>
              <label style={{ ...labelStyle, fontSize: '11px' }}>Rótulo (opcional)</label>
              <input
                type="text"
                value={item.label}
                onChange={(e) => setMediaItem(i, 'label', e.target.value)}
                placeholder="Ex.: Ver cardápio PDF"
                style={{ ...inputStyle, marginTop: '6px' }}
              />
            </div>
            <div>
              <label style={{ ...labelStyle, fontSize: '11px' }}>Contexto para o agente</label>
              <input
                type="text"
                value={item.description}
                onChange={(e) => setMediaItem(i, 'description', e.target.value)}
                placeholder="Ex.: quando pedir cardápio ou menu"
                style={{ ...inputStyle, marginTop: '6px' }}
              />
            </div>
          </div>
        </div>
      ))}
      <button type="button" onClick={addMediaItem} style={styles.smallButton}>
        + Adicionar mídia
      </button>
    </div>
  );
}
